import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

export default function TypingIndicator() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1, mb: 1.5 }}>
      <Avatar sx={{ width: 30, height: 30, bgcolor: 'primary.main', flexShrink: 0, mb: 0.25 }}>
        <AutoAwesomeIcon sx={{ fontSize: 16 }} />
      </Avatar>
      <Box
        sx={{
          px: 1.75,
          py: 1.25,
          borderRadius: '4px 12px 12px 12px',
          bgcolor: 'primary.main',
          boxShadow: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 7,
              height: 7,
              borderRadius: '50%',
              bgcolor: 'primary.contrastText',
              opacity: 0.7,
              animation: 'bounce 1.2s infinite',
              animationDelay: `${i * 0.2}s`,
              '@keyframes bounce': {
                '0%, 60%, 100%': { transform: 'translateY(0)' },
                '30%': { transform: 'translateY(-6px)' },
              },
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
